import React from 'react'
import { Error } from '../Error/Error'
import { ErrorSpinner } from '../ErrorSpinner/ErrorSpinner'
import { IGlobalError } from '../../context/GlobalError'

interface Props {
  loading: boolean
  error: IGlobalError | undefined | null
  children?: any
}

export const ErrorHandler: React.FC<Props> = ({ children, loading, error }) => {
  if (error?.status === 401) {
    window.location.href = '/login'
    return null
  }

  if (error) {
    return <Error error={error} />
  }

  if (loading) {
    return <ErrorSpinner>{children}</ErrorSpinner>
  }

  return <>{children}</>
}
